<template>
    <img alt="logo" class="rounded-lg" src="/storage/img/logo.jpg">
</template>
